import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { HugeiconsIconComponent } from '@hugeicons/angular';
import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-pagination',
    standalone: true,
    imports: [HugeiconsIconComponent],
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnChanges {
    protected readonly Math = Math;
    @Input() totalItems: number = 0;
    @Input() itemsPerPage: number = 10;
    @Input() currentPage: number = 1;
    @Input() maxSize: number = 5; // Max number of page buttons to show

    @Output() pageChange = new EventEmitter<number>();

    // Icons
    arrowLeftIcon = ArrowLeft01Icon;
    arrowRightIcon = ArrowRight01Icon;

    pages: number[] = [];
    totalPages: number = 0;

    ngOnChanges(changes: SimpleChanges): void {
        this.calculatePages();
    }

    calculatePages(): void {
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.pages = [];

        if (this.totalPages <= this.maxSize) {
            for (let i = 1; i <= this.totalPages; i++) {
                this.pages.push(i);
            }
        } else {
            let startPage = Math.max(1, this.currentPage - Math.floor(this.maxSize / 2));
            let endPage = startPage + this.maxSize - 1;

            if (endPage > this.totalPages) {
                endPage = this.totalPages;
                startPage = Math.max(1, endPage - this.maxSize + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                this.pages.push(i);
            }
        }
    }

    setPage(page: number): void {
        if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
            this.pageChange.emit(page);
        }
    }

    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.setPage(this.currentPage + 1);
        }
    }

    prevPage(): void {
        if (this.currentPage > 1) {
            this.setPage(this.currentPage - 1);
        }
    }
}
